export const SEE_MORE = 'Voir plus';
export const SEE_LESS = 'Voir moins';
export const KNOW_MORE = 'En savoir plus';
